
/* スムーズスクロール
------------------------------------------ */

function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

function smoothScrollToY(targetY, duration) {
  const startY = window.pageYOffset || document.documentElement.scrollTop || 0;
  const diff = targetY - startY;
  const start = performance.now();

  function step(now) {
    const elapsed = now - start;
    const t = Math.min(1, elapsed / duration);
    const eased = easeInOutCubic(t);
    window.scrollTo(0, startY + diff * eased);
    if (t < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}

const smoothScrollTrigger = document.querySelectorAll('.smoothScroll');
for (let i = 0; i < smoothScrollTrigger.length; i++) {
  smoothScrollTrigger[i].addEventListener('click', (e) => {
    const href = smoothScrollTrigger[i].getAttribute('href') || '';

    // 同一ページ内アンカー（#xxx）のときだけスムーススクロール
    if (!href.startsWith('#')) return;

    const id = href.slice(1);
    const targetElement = document.getElementById(id);
    if (!targetElement) return;

    e.preventDefault();

    const rectTop = targetElement.getBoundingClientRect().top;
    const offsetY = window.pageYOffset || 0;
    const gap = 0;
    const targetY = rectTop + offsetY - gap;
    smoothScrollToY(targetY, 1100);
  });
}

$(document).ready(function () {
    var $menu = $('.site_header_menu');

    function closeHeaderMenu() {
      $('.openbtn').removeClass('active').removeAttr('id');
      $menu.css('pointer-events', 'none').fadeOut(400, function () {
        $(this).css({ display: 'none', pointerEvents: '' });
      });
    }

    // ヘッダーの開くボタン：メニューを開くだけ
    $('.site_header .openbtn').on('click', function (e) {
      $(this).addClass('active').attr('id', 'active-btn');
      $menu.css('display', 'flex').hide().fadeIn(400);
    });

    // メニュー内の閉じるボタン：メニューを閉じるだけ（開く処理は走らせない）
    $('.site_header_menu_close').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeHeaderMenu();
    });

    // モバイルメニュー内のアンカー遷移時はメニューを閉じる
    $menu.on('click', 'a[href*="#home_event"]', function () {
      closeHeaderMenu();
    });
  });

  $(function () {
    // モーダル内のYouTube iframeを停止（閉じたときに再生を止める）
    function stopYouTubeInModal(modalSelector) {
      $(modalSelector).find('iframe[src*="youtube.com"]').each(function () {
        var iframe = this;
        var src = iframe.src;
        if (src) {
          $(iframe).attr('data-youtube-src', src);
          iframe.src = 'about:blank';
        }
      });
    }
    // モーダルを開くときにYouTube iframeのsrcを復元
    function restoreYouTubeInModal(modalSelector) {
      $(modalSelector).find('iframe[data-youtube-src]').each(function () {
        var src = $(this).attr('data-youtube-src');
        $(this).attr('src', src).removeAttr('data-youtube-src');
      });
    }

    $('#openModal').on('click', function () {
      restoreYouTubeInModal('#modalArea');
      $('#modalArea').fadeIn();
    });
    $('.js-openModalVision').on('click', function () {
      restoreYouTubeInModal('#modalAreaVision');
      $('#modalAreaVision').fadeIn();
    });
    $('#closeModal, #modalBg').on('click', function () {
      stopYouTubeInModal('#modalArea');
      $('#modalArea').fadeOut();
    });
    $('#closeModalVision, #modalBgVision').on('click', function () {
      stopYouTubeInModal('#modalAreaVision');
      $('#modalAreaVision').fadeOut();
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".site_header");
    const mv = document.querySelector(".mv, .c-subPage_mv, .c-section_head-detail");

    // トップバー（40px）がスクロールで隠れたらヘッダーを上にスライド（CSS transition が確実に効くように reflow を挟む）
    if (header) {
      function topbarScroll() {
        if (window.scrollY > 40) {
          if (!header.classList.contains("past-topbar")) {
            void header.offsetHeight; // reflow で現在の transform を確定させてからクラス追加
            header.classList.add("past-topbar");
          }
        } else {
          if (header.classList.contains("past-topbar")) {
            void header.offsetHeight;
            header.classList.remove("past-topbar");
          }
        }
      }
      window.addEventListener("scroll", topbarScroll);
      topbarScroll();
    }

    if (!header || !mv) return;

    function handleScroll() {
      const mvHeight = mv.offsetHeight;
      const scrollY = window.scrollY || window.pageYOffset;

      if (scrollY > mvHeight) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // 初回実行
  });

const carousel01Swiper = new Swiper('.vision_contents_item-01 .swiper', {
    loop: true,
    slidesPerView: "auto",
    speed: 30000,
    allowTouchMove: true,
    autoplay: {
        delay: 0,
    },
});

const carousel02Swiper = new Swiper('.vision_contents_item-02 .swiper', {
    loop: true,
    slidesPerView: "auto",
    speed: 30000,
    allowTouchMove: true,
    autoplay: {
        delay: 0,
    },
});

const carousel03Swiper = new Swiper('.vision_contents_item-03 .swiper', {
    loop: true,
    slidesPerView: "auto",
    speed: 30000,
    allowTouchMove: true,
    autoplay: {
        delay: 0, // 途切れなくループ
    },
});

